// @flow
import React, { Component } from "react";
import _ from "lodash";
import moment from "moment";
import enhanceWithClickOutside from "react-click-outside";
import I18n from "../../../i18n/I18n";
import Helper from "../../../helper/Helper";
import { Icon, LocaleLink } from "../";
import styles from "./Profile.scss";

class Profile extends Component {
  state = {
    showList: false
  };

  toggleList = () => {
    this.setState(prevState => ({
      showList: !prevState.showList
    }));
  };

  handleClickOutside = () => {
    this.setState({ showList: false });
  };

  render() {
    const { data, user, seller, signout } = this.props;
    return (
      <div className={styles.notificationIcon}>
        <div className={styles.icon} onClick={this.toggleList}>
          <Icon name="user" />
          <span className={styles.uName}>
            {" "}
            {seller ? seller.storeName || "" : ""}
          </span>
          <Icon
            name={this.state.showList ? "angle-up" : "angle-down"}
            className={styles.arr}
          />
          {/**<span className={styles.uName}>{user && user.firstName}</span>
          <Icon
            name={this.state.showList ? "angle-up" : "angle-down"}
            className={styles.arr}
          />**/}
        </div>
        {this.state.showList && (
          <div className={styles.list}>
            <div className={styles.listCtr}>
              <div className={styles.listWrapper}>
                <div className={styles.proDetails}>
                  <h4 className={styles.userName}>
                    {I18n.getText("menu.signed-in-as")}
                    <p>{user ? user.firstName : ""}</p>
                  </h4>
                </div>
                <div className={styles.menuItems}>
                  <div className={styles.each} onClick={() => signout()}>
                    {I18n.getText("menu.logout")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default enhanceWithClickOutside(Profile);



// WEBPACK FOOTER //
// ./src/components/common/profile/Profile.js